import api from './api'
import { toast } from 'react-toastify'

export function findLogsByFormula(farmaciaId, formulaId) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem('FORMULARIO_JSONWEBTOKEN');

      const response = await api.get(`/farmacias/${farmaciaId}/formulas/${formulaId}/logs`, {
        headers: { authorization: `Bearer ${token}` }
      });

      return resolve(response.data.data);
    } catch (e) {
      toast.error("Falha ao buscar logs da fórmula");
      return reject(e);
    }
  })
}

export function clearLogs(farmaciaId, formulaId, usuarioId) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem('FORMULARIO_JSONWEBTOKEN');

      await api.delete(`/farmacias/${farmaciaId}/formulas/${formulaId}/logs`, {
        headers: { authorization: `Bearer ${token}` },
        params: { usuarioId }
      });

      return resolve();
    } catch (e) {
      toast.error("Falha ao limpar logs do ativo");
      return reject(e);
    }
  })
}
